import { createRouter, createWebHistory, type RouteRecordRaw} from 'vue-router'
import { useAuthorization }                                   from '@/stores/AuthorizationStore'
import { conektaRoutes                                      } from './modules/conekta.routes'
import { toolsRoutes                                      } from './modules/tools.routes'
import { cesispeRoutes                                      } from './modules/cesispe.routes'
import { reportsRoutes                                      } from './modules/reports.routes'

const routes: Array<RouteRecordRaw> = [
    {
        path: '',
        name: 'DefaultLayout',
        component: () => import("../layouts/DefaultLayout.vue"),
        children: [
            {
                path: '',
                name: 'Home',
                component: () => import('@/views/home/HomeView.vue'),                
                meta:{
                    requireAuth:true
                }
            },            

        ]
    },

    {
        path: '',
        name: 'AuthGatewayLayout',
        component: () => import("../layouts/AuthGatewayLayout.vue"),
        children: [

            {
                path: '/AuthGateway', 
                redirect: { name: 'Home' },
                name: 'AuthGateway',
                component: () => import('@/views/authgateway/AuthGateWayHomeView.vue'),
                meta:{
                    requireAuth:true
                },
                children: [
                    {
                        path: '/AuthGateway/DashBoard',
                        name: 'AuthGatewayDashBoard',
                        component: () => import('@/modules/authgateway/dashBoard/view/dashBoard.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    {
                        path: '/AuthGateway/UsersTypes',
                        name: 'AuthGatewayUsersTypes',
                        component: () => import('@/modules/authgateway/usertypes/view/AuthGatewayUsersTypes.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },
                    {
                        path: '/AuthGateway/Apps',
                        name: 'AuthGatewayApps',
                        component: () => import('@/modules/authgateway/apps/view/AuthGatewayApps.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    {
                        path: '/AuthGateway/Apps/DashBoard',
                        name: 'MaintenanceDashBoard',
                        component: () => import('@/modules/authgateway/apps/view/AuthGatewayAppsMaintenance .vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    {
                        path: '/AuthGateway/Modules',
                        name: 'AuthGatewayModules',
                        component: () => import('@/modules/authgateway/modules/view/AuthGatewayModules.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    {
                        path: '/AuthGateway/Actions',
                        name: 'AuthGatewayActions',
                        component: () => import('@/modules/authgateway/actions/view/AuthGatewayActions.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    {
                        path: '/AuthGateway/Permissions',
                        name: 'AuthGatewayPermissions',
                        component: () => import('@/modules/authgateway/pemissions/view/AuthGatewayPermissions.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    {
                        path: '/AuthGateway/Roles',
                        name: 'AuthGatewayRoles',
                        component: () => import('@/modules/authgateway/roles/view/AuthGatewayRoles.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    {
                        path: '/AuthGateway/Users',
                        name: 'AuthGatewayUsers',
                        component: () => import('@/modules/authgateway/users/view/AuthGatewayUsers.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    {
                        path: '/AuthGateway/Logins',
                        name: 'AuthGatewayLoginSessions',
                        component: () => import('@/modules/authgateway/loginSessions/view/AuthGatewayLoginSessions.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    {
                        path: '/AuthGateway/WhiteListIp',
                        name: 'AuthGatewayWhiteListIp',
                        component: () => import('@/modules/authgateway/whiteList/view/AuthGatewayWhiteList.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    {
                        path: '/AuthGateway/AuditLogs',
                        name: 'AuthGatewayAuditLogs',
                        component: () => import('@/modules/authgateway/auditLogs/view/AuthGatewayAuditLogs.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    {
                        path: '/AuthGateway/Consumers',
                        name: 'AuthGatewayConsumer',
                        component: () => import('@/modules/authgateway/consumers/view/AuthGatewayConsumer.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    {
                        path: '/AuthGateway/AccessTokens',
                        name: 'AuthGatewayAccessToken',
                        component: () => import('@/modules/authgateway/accessToken/view/AuthGatewayAccessToken.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    {
                        path: '/AuthGateway/RefreshTokens',
                        name: 'AuthGatewayRefreshToken',
                        component: () => import('@/modules/authgateway/refreshToken/view/AuthGatewayRefreshToken.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    {
                        path: '/AuthGateway/ApiLogs',
                        name: 'AuthGatewayApiLogs',
                        component: () => import('@/modules/authgateway/apiLogs/view/AuthGatewayApiLogs.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    {
                        path: '/AuthGateway/SystemLogs',
                        name: 'AuthGatewaySystemLogs',
                        component: () => import('@/modules/authgateway/systemLogs/view/AuthGatewaySytemLogs.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },                    
                    {
                        path: '/AuthGateway/ConfigurationSettings',
                        name: 'AuthGatewayConfigurationSettings',
                        component: () => import('@/modules/authgateway/configurationSettings/view/AuthGatewayConfigSettings.vue'),
                        meta:{
                            requireAuth:true
                        }
                    },
                    
                ]
            },          

        ]
    },

    {
        path: '',
        component: () => import("@/layouts/OperationsLayout.vue"),
        children: [
            {
                redirect: { name: 'Home' },
                path: '/Operations',
                name: 'Operations',                
                component: () => import('@/views/operations/operationsHomeView.vue'),                
                meta:{
                    requireAuth:true
                },
                children: [
                    {
                        path: '/Operations/Clients',
                        name: 'OperationsClients',
                        component: () => import('@/modules/operations/clients/view/operationsClients.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },
                    {
                        path: '/Operations/Branches',
                        name: 'OperationsBranches',
                        component: () => import('@/modules/operations/branches/view/branchesList.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },
                    {
                        path: '/Operations/LocationTypes',
                        name: 'OperationsLocationTypes',
                        component: () => import('@/modules/operations/locationTypes/view/typesList.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },
                    
                    {
                        path: '/Operations/Locations',
                        name: 'OperationsLocations',
                        component: () => import('@/modules/operations/locations/view/locationsList.vue'),
                        meta:{
                            requireAuth:true
                        }                        
                    },

                    {
                        path: '/Operations/AreasTypes',
                        name: 'OperationsAreasTypes',
                        component: () => import('@/modules/operations/areasTypes/view/typesList.vue'),
                        meta:{
                            requireAuth:true
                        }                        
                    },

                    {
                        path: '/Operations/Areas',
                        name: 'OperationsAreas',
                        component: () => import('@/modules/operations/areas/view/areasList.vue'),
                        meta:{
                            requireAuth:true
                        }                        
                    },

                    {
                        path: '/Operations/StationsTypes',
                        name: 'OperationsStationsTypes',
                        component: () => import('@/modules/operations/stationsTypes/view/typesList.vue'),
                        meta:{
                            requireAuth:true
                        }                        
                    },

                    {
                        path: '/Operations/Stations',
                        name: 'OperationsStations',
                        component: () => import('@/modules/operations/stations/view/stationsList.vue'),
                        meta:{
                            requireAuth:true
                        }                        
                    },

                    {
                        path: '/Operations/DevicesTypes',
                        name: 'OperationsDevicesTypes',
                        component: () => import('@/modules/operations/deviceTypes/view/typesList.vue'),
                        meta:{
                            requireAuth:true
                        }                        
                    },

                    {
                        path: '/Operations/Devices',
                        name: 'OperationsDevices',
                        component: () => import('@/modules/operations/devices/view/devicesBase.vue'),
                        meta:{
                            requireAuth:true
                        }                        
                    },

                    {
                        path: '/Operations/ServicesTypes',
                        name: 'OperationsServicesTypes',
                        component: () => import('@/modules/operations/servicesTypes/view/typesList.vue'),
                        meta:{
                            requireAuth:true
                        }                        
                    },
                    {
                        path: '/Operations/servicesRequestTypes',
                        name: 'OperationsServicesRequestTypes',
                        component: () => import('@/modules/operations/servicesRequestTypes/view/typesList.vue'),
                        meta:{
                            requireAuth:true
                        }                        
                    },
                    {
                        path: '/Operations/servicesRequest',
                        name: 'OperationsServicesRequest',
                        component: () => import('@/modules/operations/servicesRequest/view/request.vue'),
                        meta:{
                            requireAuth:true
                        }                        
                    },
                    {
                        path: '/Operations/servicesSchedules',
                        name: 'OperationsServicesSchedules',
                        component: () => import('@/modules/operations/servicesSchedules/view/schedules.vue'),
                        meta: {
                            requireAuth: true
                        }
                    },
                    
                                        
                ]
            },
            
        ]
    },

    {
        path: '',
        component: () => import("@/layouts/PaymentsLayout.vue"),
        children: [
            {
                redirect: { name: 'Home' },
                path: '/Payments',
                name: 'payments',
                component: () => import('@/views/payments/paymentsHomeView.vue'),                
                meta:{
                    requireAuth:true
                },
                children: [
                    {
                        path: '/Payments/dashboard',
                        name: 'PaymentsDashBoard',
                        component: () => import('@/modules/payments/dashBoard/view/dashBoard.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },  

                    {
                        path: '/Payments/transactions',
                        name: 'PaymentsTransactions',
                        component: () => import('@/modules/payments/transactions/view/listTransaction.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },
                    
                    {
                        path: '/Payments/transactions-pendings',
                        name: 'PaymentsTransactionsPendings',
                        component: () => import('@/modules/payments/transactions/view/listTransactionPending.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },
                    
                    {
                        path: '/Payments/reports',
                        name: 'PaymentsReports',
                        component: () => import('@/modules/payments/transactions/view/paymentsReports.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },
                ]
            },
            
        ]
    },
    
    {
        path: '',
        component: () => import("@/layouts/OperationsToolsLayout.vue"),
        children: [
            {
                redirect: { name: 'Home' },
                path: '/trc',
                name: 'OperationsTools',
                component: () => import('@/views/payments/paymentsHomeView.vue'),                
                meta:{
                    requireAuth:true
                },
                children: [
                    {
                        path: '/trc/reports/card-accreditation',
                        name: 'trc.reports.card-accreditation',
                        component: () => import('@/modules/operationsTools/Trc/presentacion/view/dashboardCardAccreditation.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },                
                    {
                        path: '/trc/cards',
                        name: 'ToolsRechargeCards',
                        component: () => import('@/modules/operationsTools/Trc/presentacion/view/baseTRC.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },
                    {
                        path: '/trc/cards/activate',
                        name: 'ToolsRechargeCardsManyLot',
                        component: () => import('@/modules/operationsTools/Trc/presentacion/view/baseManyLot.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },  
                    
                    {
                        path: '/trc/cards/create',
                        name: 'ToolsRechargeCreateLot',
                        component: () => import('@/modules/operationsTools/Trc/presentacion/view/baseCreateLot.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },  

                    {
                        path: '/trc/cards/assigned',
                        name: 'ToolsRechargeSearchAssigned',
                        component: () => import('@/modules/operationsTools/Trc/presentacion/view/searchAssigned.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },
                    
                    {
                        path: '/trc/cards/list-blocked',
                        name: 'ToolsRechargeCardsBlocked',
                        component: () => import('@/modules/operationsTools/Trc/presentacion/view/listCardsBlocked.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },
                    
                    {
                        path: '/trc/cards/api-ivr-trc',
                        name: 'ToolsAPIIVTRC',
                        component: () => import('@/modules/operationsTools/Trc/presentacion/view/api/apiTemplate.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },
                    
                                          
                        
                    
                ]
            },
            
        ]
    },
    
    
    {
        path: '',
        component: () => import("../layouts/BlankLayout.vue"),
        children: [
            {
                path: '/Auth/Login',
                name: 'Login',
                component: () => import('@/views/auth/LoginMain.vue'),                
                meta:{
                    requireAuth:false
                }
            },
            {
                path: '/auth/Recovery-Password',
                name: 'Recovery',
                component: () => import('@/views/auth/Recovery-Password.vue'),
                meta:{
                    requireAuth:false
                }
            },
            {
                path: '/:catchAll(.*)',
                name: 'NotFound',
                component: () => import('@/components/pagesErrors/404Template.vue'),
                meta: {
                    requireAuth: false
                }
            },
            {
                path: '/error',
                name: 'ServerError',
                component: () => import('@/components/pagesErrors/500Template.vue'),
                meta: {
                    requireAuth: false
                }
            }
        ]
    },
    
    {
        path: '',
        component: () => import("@/layouts/NotificationsLayout.vue"),
        children: [
            {
                redirect: { name: 'Home' },
                path: '/Notifications',
                name: 'Notifications',
                component: () => import('@/views/notifications/notificationsHomeView.vue'),                
                meta:{
                    requireAuth:true
                },
                children: [
                    {
                        path: '/Notifications/DashBoard',
                        name: 'NotificationsDashBoard',
                        component: () => import('@/modules/notifications/dashBoard/view/dashBoard.vue'),
                        meta:{
                            requireAuth:true
                        }
                        
                    },  

                ]
            },
            
        ]
    },

    ...toolsRoutes,
    ...conektaRoutes,
    ...cesispeRoutes,
    ...reportsRoutes

]

const router = createRouter({ history: createWebHistory(), routes })

router.beforeEach((to, from, next) => {
  const auth = useAuthorization()
  if (to.meta.requireAuth && !auth.statusLogin) {
    return next({ path: '/Auth/Login' })
  }

  if (to.path === '/Auth/Login' && auth.statusLogin) {
    return next({ path: '/' })
  }

  next()
})
    
export default router